import { packIntoFormData } from "../utilities/apiUtilities";
import axiosInstance from "../auth/axioInstance";

// const controllerUrl = `${process.env.REACT_APP_API}/horse`
const controllerUrl = `/horse`

function createHorse(horseCreateViewModel) {

    return axiosInstance.post(`${controllerUrl}`, packIntoFormData(horseCreateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
    // return Axios.post(`${controllerUrl}`, packIntoFormData(horseCreateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
}

function indexHorses({sortOrder = "", searchString = "", pageSize = 50, pageNumber = 1}) {

    return axiosInstance.get(`${controllerUrl}`, { params: {sortOrder: sortOrder, searchString: searchString, pageSize: pageSize, pageNumber: pageNumber}});
}

function getHorse(id) {
    return axiosInstance.get(`${controllerUrl}/${id}`);
}

function updateHorse(id, horseCreateViewModel) {
    return axiosInstance.put(`${controllerUrl}/${id}`, packIntoFormData(horseCreateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
}

function deleteHorse(id) {
    return axiosInstance.delete(`${controllerUrl}/${id}`);
}

export const horseService = {
    createHorse,
    indexHorses,
    getHorse,
    deleteHorse,
    updateHorse
}